import { CAPTION_SERVICES, MentionRef } from "./protocol";

interface TaggedPostData {
  mentions?: unknown;
  socialMentions?: unknown;
}

// The editor writes the tags it holds to socialMentions per service as the text changes; until it does, a loaded post only has mentions.
export const collectMentions = (postData: TaggedPostData): MentionRef[] => {
  const live = (postData.socialMentions ?? {}) as Record<string, MentionRef[]>;
  const stored = (postData.mentions ?? []) as MentionRef[];
  return CAPTION_SERVICES.flatMap(service => live[service] ?? stored.filter(mention => mention.service === service));
};

export const isSameMention = (a: MentionRef, b: MentionRef) => a.service === b.service && a.id === b.id;

// A replaced caption gets back only the tags in mentions, while a tag typed by hand sits in socialMentions until the post is saved.
export const mentionsForReplacedCaption = (postData: TaggedPostData, added: MentionRef[]): MentionRef[] => {
  const current = collectMentions(postData);
  return [...current, ...added.filter(candidate => !current.some(mention => isSameMention(mention, candidate)))];
};
